<template>
  <span class="align-center">
    <div v-if="showCompanyName&&orgInfo.name" class="align-center">
      <span class="company">{{orgInfo.name || ''}}</span>
      <div class="divider"></div>
    </div>
    <el-popover style="padding: 0;" placement="bottom-start" trigger="click" width="187" v-model="visible" :visible-arrow="false">
      <span class="align-center" style="cursor: pointer;" slot="reference">
        <head-img :size="34" style="border-radius: 50%;" :src="userInfo.profilePicture" :name="userInfo.name" />
        <span class="username">{{userInfo.name}}</span>
        <i class="el-icon-caret-bottom"></i>
      </span>
      <div class="align-center">
        <head-img :size="42" style="border-radius: 50%;margin: 7px 14px 0 13px;" :src="userInfo.profilePicture" :name="userInfo.name" />
        <div>
          <div class="user-name">
            {{userInfo.name}}
          </div>
          <div class="user-info">
            {{userInfo.type | memberType}}
          </div>
        </div>
      </div>
      <div class="pop-divider"></div>
      <div class="pop-footer">
        <el-button type="primary" size="mini" style="padding: 6px 17px;" @click="exit">退出</el-button>
      </div>
    </el-popover>
  </span>
</template>

<script>
import HeadImg from '@/components/HeadImg'
import { mapState, mapActions} from 'vuex'
export default {
  name: 'userPopover',
  data () {
    return {
      visible: false
    }
  },
  props: {
    showCompanyName: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    memberType (type) {
      switch (type) {
        case 0:
          return '普通员工'
        case 1:
          return '子管理员'
        case 2:
          return '主管理员'
        default:
          break
      }
      return ''
    }
  },
  components: {
    HeadImg
  },
  computed: {
    ...mapState('user', ['userInfo', 'orgInfo'])
  },
  methods: {
    ...mapActions('user', ['ExitUser']),
    exit () {
      this.visible = false
      this.ExitUser()
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.pop-footer{
  display: flex;
  justify-content: center;
}
.pop-divider{
  left: -11px;
  position: relative;
  width: 211px;
  height: 1px;
  background-color: #EDEDED;
  margin-top: 24px;
  margin-bottom: 11px;
}
.user-info{
  color: rgba(0,0,0,0.65);
  font-size: 12px;
}
.username{
  font-size: 14px;
  margin-left: 6px;
}
.user-name{
  color: rgba(0,0,0,0.65);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
.divider{
  display: inline-block;
  width: 1px;
  height: 20px;
  background-color: rgba(255,255,255,0.3);
  margin: 0 17px;
}
</style>
